<template>
  <div
    @mouseenter="setActionsVisible(true)"
    @mouseleave="setActionsVisible(false)"
  >
    <slot name="btn">
      <BtnDefault
        mode="icon"
        :btnProps="btnPropsComputed"
      />
    </slot>
    <q-popup-proxy
      v-model="actionsVisible"
      @mouseenter="setActionsVisible(true)"
      @mouseleave="setActionsVisible(false)"
    >
      <slot></slot>
    </q-popup-proxy>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { debounce } from "quasar";

export default defineComponent({
  name: "BtnDropdown",
  components: {},
  props: {
    mode: {
      type: String as PropType<"default" | "icon" | "item">,
      default: "icon",
    },
    btnProps: {
      type: Object,
      default: () => ({}),
    },
    closeByClick: Boolean,
  },
  computed: {
    btnPropsComputed(): any {
      return {
        ...this.modeProps[this.mode],
        ...this.btnProps,
      };
    },
  },
  data() {
    return {
      modeProps: {
        default: {
          label: "Click for more",
        },
        icon: {
          icon: "expand_more",
          tooltip: "Click for more",
        },
        item: {
          label: "Click for more",
        },
      },
      actionsVisible: false,
    };
  },
  watch: {},
  methods: {
    setActionsVisible(value: boolean) {
      if (value || !this.closeByClick) {
        this.actionsVisible = value;
      }
    },
  },
  created() {
    this.setActionsVisible = debounce(this.setActionsVisible, 10);
  },
});
</script>

<style lang="scss"></style>
